import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Ensure AOS CSS is imported

const EthiccraftActionSection = () => {
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // 'once: true' makes animations run only once

    // Fetch the image from the API
    fetch("https://ethiccraft.org/backend/gallery/read_isShown.php") // Replace with your actual API URL
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Ensure data is an array and has at least one item with an 'image' property
        if (Array.isArray(data) && data.length > 0 && data[0].image) {
          setImageUrl(data[0].image);
        } else {
          console.warn("API response for image is empty or malformed:", data);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch image:", error);
      });
  }, []); // Empty dependency array ensures this runs only once on mount

  const features = [
    {
      icon: "🧭",
      title: "Values-Based Activities",
      desc: "From discussions to campus campaigns, every Ethiccraft activity is designed to nurture integrity, empathy, and leadership.",
    },
    {
      icon: "🛠️",
      title: "Skill-Building Opportunities",
      desc: "Workshops, drives, and real-world projects help you build communication, teamwork, and decision-making skills — all rooted in values.",
    },
    {
      icon: "🌍",
      title: "Community-Driven Impact",
      desc: "Be part of a mission-focused network that turns ideas into action and creates meaningful change on and off campus.",
    },
  ];

  return (
    <div className="ethicraft-action-container">
      <div className="ethicraft-action-content" data-aos="fade-right">
        <h1 className="ethicraft-action-title">
          <span>✨ Ethiccraft </span> In Action{" "}
        </h1>
        <div className="ethicraft-action-features">
          {features.map((feature, index) => (
            <div
              key={index}
              className="ethicraft-feature-item"
              data-aos="fade-up"
              data-aos-delay={index * 200}
            >
              <div className="ethicraft-feature-icon">{feature.icon}</div>
              <div className="ethicraft-feature-text">
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="ethicraft-action-image-container" data-aos="fade-left">
        <div className="ethicraft-image-wrapper">
          {imageUrl ? (
            <img
              src={`https://ethiccraft.org/${imageUrl}`}
              alt="Ethiccraft activity in action"
              className="ethicraft-action-image"
            />
          ) : (
            // Placeholder or loading spinner if image is not yet loaded
            <div className="ethicraft-image-placeholder">Loading Image...</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EthiccraftActionSection;